"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_1 = __importDefault(require("@emotion/styled"));
var box_1 = require("./box");
exports.Icon = styled_1.default(box_1.Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n\n  svg {\n    display: block;\n  }\n"], ["\n  display: block;\n\n  svg {\n    display: block;\n  }\n"])));
exports.Icon.defaultProps = {
    as: "i"
};
exports.Icon.displayName = "logo";
var templateObject_1;
